import { useOrgResolvedFlag } from './useOrgResolvedFlag';

export const VISUALIZE_GEOREFERENCED_MAPS_FLAG = 'visualize-georeferenced-maps';

export function useVisualizeGeoreferencedMapsEnabled(): { resolved: boolean; enabled: boolean } {
  return useOrgResolvedFlag(VISUALIZE_GEOREFERENCED_MAPS_FLAG);
}
